<template>
<div class="home">
  <b-jumbotron header="MBN" lead="Plantørring">
    <div class="float-right adjust"><img :src="require('../assets/frontpic.jpg')"></div>
    <p>Vi er et firma, der startede i 1988 med opretning af rundbuede kanaler og salg af nye. Erfaringen går tilbage til 1964, med opbygning og indretning af korntørringsanlæg, samt transport af korn m.m. </p>
    <p>Læs mere under produkter eller kontakt os for et tilbud.</p>
  </b-jumbotron>
</div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {}
  }
}
</script>

<style scoped>
.home {
  margin-top: 100px;
}

.adjust {
  margin-top: -180px
}
</style>
